import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=b00c221a&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Overview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=b00c221a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00c221a",
  null
  
)

export default component.exports